import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A standalone oil-filled distribution transformer on a concrete plinth: a grey
// tank flanked by cooling-fin radiators, a conservator drum on top, three tall
// HV porcelain bushings and three short LV bushings. The workhorse that steps
// voltage between lines.
const TANK = "#8a9197";
const FIN = "#767d83";
const INSUL = "#9aa6ad";
const LV = "#b87333";
const PLINTH = "#9a948a";

export const distributionTransformer = defineModel({
  id: "distribution-transformer",
  batchId: "electric",
  name: "Distribution transformer",
  tags: ["prop", "electric", "power", "grid", "distribution", "transformer"],
  summary: "An oil-filled transformer with radiators, conservator and bushings.",
  footprint: 0.4,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(0.6, 0.1, 0.5), color: PLINTH, position: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.42, 0.42, 0.36), color: TANK, position: [0, 0.31, 0] },
      // Radiator fin banks on both sides.
      { geometry: new THREE.BoxGeometry(0.06, 0.36, 0.3), color: FIN, position: [-0.25, 0.31, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.36, 0.3), color: FIN, position: [0.25, 0.31, 0] },
      // Conservator drum on top.
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.36, 10), color: TANK, position: [0, 0.58, -0.14], rotation: [0, 0, Math.PI / 2] },
      // Lid.
      { geometry: new THREE.BoxGeometry(0.44, 0.04, 0.38), color: "#7a8086", position: [0, 0.54, 0] },
    ];
    // Three tall HV bushings (front) and three short LV bushings (back).
    for (const x of [-0.13, 0, 0.13]) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.025, 0.035, 0.22, 8), color: INSUL, position: [x, 0.67, 0.1] });
      parts.push({ geometry: new THREE.SphereGeometry(0.028, 6, 5), color: "#7a8086", position: [x, 0.79, 0.1] });
    }
    for (const x of [-0.1, 0.1]) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.02, 0.026, 0.12, 8), color: LV, position: [x, 0.62, -0.12] });
    }
    return parts;
  },
  animations: [],
});
